<template>
  <IModal>
    <p :class="$style.title"><i class="icon-envelope-o"></i>再出品メールに登録しました</p>
    <p>メールが届かない場合、ご入力いただいたメールアドレスに誤りがある、またはiichi.comのドメイン許可設定がされていない場合がございます。</p>
  </IModal>
</template>

<script setup lang="ts">
import IModal from '@/js/components/molecules/IModal.vue';
</script>

<style module lang="scss">
.title {
  font-weight: bold;
  margin: 10px 0 25px;
  text-align: center;

  [class^='icon-'] {
    margin-right: 6px;
    position: relative;
    top: 1px;
  }
}
</style>
